module.exports = global["Flow"] = require("-!./ng-flow-standalone.js");